import { z } from 'zod'

import { StringDtoSchema } from '@hcr/api/shared'

const PointsExchangeInfoContentDtoSchema = z.strictObject({})

export const PointsExchangeInfoDtoSchema = z.strictObject({
  imageUrl: StringDtoSchema.url().nullable(),
  title: StringDtoSchema,
  description: StringDtoSchema,
  link: StringDtoSchema.nullable(),
  content: z.array(PointsExchangeInfoContentDtoSchema),
})

export type PointsExchangeInfoDto = z.infer<typeof PointsExchangeInfoDtoSchema>

export const isPointsExchangeInfoDto = (x: unknown): x is PointsExchangeInfoDto =>
  PointsExchangeInfoDtoSchema.safeParse(x).success
